import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { isMobile } from '../utilities/breakpoints';
const { processAlertMessage } = require('../accessibility/accessibilityHelper');

$(document).ready(function () {
    $('.reassurance').each(function () {
        if (isMobile()) {
            const swiperItem = new Swiper(this, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.2,
                centeredSlides: false,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                loop: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                on: {
                    slideChangeTransitionEnd(swiper) {
                        processAlertMessage('Showing reassurance carousel slide ' + (swiper.realIndex + 1), true);
                    }
                }
            });

            $(this).find('.swiper-slide').on('click', function () {
                const index = $(this).index();
                if (index !== swiperItem.activeIndex) {
                    swiperItem.slideTo(index);
                }
            });
        }
    });
});